import MenuButtonComponentWrapper from '../wrappers/MenuButtonComponentWrapper';
import SkyClickPlayer from './SkyClickPlayer';

export default class PlaylistNextButton extends MenuButtonComponentWrapper{

    // Define default name of component. It used for component instantiation by string (player.addChild('componentName')).
    // So we have the ability to load the component instance by name (player.getChild('componentName').
    public name_ = 'PlaylistNextButton';

    protected clickHandler:Function = null;

    constructor(skyClickPlayer:SkyClickPlayer,options:any = {}){
        super(skyClickPlayer,options);
        this.clickHandler = options.clickHandler;
    }

    public buildCSSClass(){
        // Add our className to the returned className
        return 'vjs-icon-next ' + super.buildCSSClass();
    }

    public handleClick(e:EventTarget) {
        this.clickHandler && this.clickHandler();
    }

}


// WEBPACK FOOTER //
// ./src/app/components/custom/PlaylistNextButton.ts